
























































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { HomebannerModule } from '@/app/store/modules/homebanner'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public imageDataCategory
  @Prop({}) public clearRowSelected

  public $v: Vuelidate

  // File Name
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public title: string = ''

  public imageSelected = null
  public imageHasSelect: any = {
    id: null,
    link: defaultImage,
  }
  // select image form

  public postData: any = {
    title: '',
    imageThumbnail: null,
    imageUrl: '',
  }
  public imageData = ''
  public previewImage(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.imageData = e.target.result
      }
      reader.readAsDataURL(input.files[0])
    }
  }
  public resetAdd() {
    this.$v.title.$reset()
    this.stateThumbnailImage = false
    this.title = ''
    this.imageHasSelect = {
      id: null,
      link: defaultImage,
    }
  }

  public changeImageCoverId(item) {
    this.stateThumbnailImage = false
    this.imageHasSelect.id = item.id
    this.imageHasSelect.link = item.link
  }
  public cancelImageThumbnailId() {
    this.stateThumbnailImage = false
    this.imageHasSelect.id = null
    this.imageHasSelect.link = defaultImage
  }

  public stateThumbnailImage = false
  public postHomebanner(item, index, button) {
    this.$v.title.$touch()
    if (this.$v.title.$invalid || this.imageHasSelect.id === null) {
      this.imageHasSelect.id === null
        ? (this.stateThumbnailImage = true)
        : (this.stateThumbnailImage = false)
    } else {
      const dataToPost = {
        name: this.title,
        imageId: this.imageHasSelect.id,
      }
      HomebannerModule.postHomebanner(dataToPost)
      this.$root.$emit('bv::hide::modal', index, button)
    }
  }
  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }

  // delete data
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    HomebannerModule.deleteHomebanner({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
